import axios from 'axios';
import config from '@/config';

export default {
  data() {
    return {
      pushRegistrationId: null,
    };
  },
  methods: {
    async initPushNotifications() {
      this.$log.debug('initializing push notifications');
      const push = PushNotification.init({
        android: {},
        ios: {
          alert: true,
          badge: true,
          sound: true,
        },
        windows: {},
      });

      push.on('registration', (data) => {
        this.$log.info('fetched device registration id for push messaging');
        this.$log.debug('registration id:', data.registrationId);
        this.pushRegistrationId = data.registrationId;
      });
    },
    async storeNewDevice(registrationId) {
      this.$log.info('storing device registration id for push messaging');
      if (this.device.platform === 'Android') {
        await this.storeFCMDevice(registrationId);
      }
      if (this.device.platform === 'iOS') {
        await this.storeAPNSDevice(registrationId);
      }
    },
    async storeFCMDevice(registrationId) {
      const data = {
        name: this.getDeviceName(),
        registration_id: registrationId,
        device_id: this.device.uuid,
        cloud_message_type: 'FCM',
      };
      try {
        const response = await axios.post(
          this.$backendUrl(config.ICOOL.API.FCM_DEVICES_PATH), data,
        );
      } catch (e) {
        this.$log.error('Storing FCM device for push notifications failed', e, e.response);
      }
    },
    async storeAPNSDevice(registrationId) {
      const data = {
        name: this.getDeviceName(),
        registration_id: registrationId,
        device_id: this.device.uuid,
      };
      try {
        const response = await axios.post(
          this.$backendUrl(config.ICOOL.API.APNS_DEVICES_PATH), data,
        );
      } catch (e) {
        this.$log.error('Storing APNS device for push notifications failed', e, e.response);
      }
    },
    getDeviceName() {
      return `${this.device.manufacturer} ${this.device.platform} ${this.device.model}`;
    },
  },
};
